// extracted by mini-css-extract-plugin
export default {"heading":"data_heading__pWpWi"};